module.exports = __webpack_public_path__ + "img/latino_loader.449411c2.svg";